import moment from 'moment';

export const phoneNumberConstraint = (value) => {
    if (value === '') {
        return true;
    }

    return /^\+33[1-9]\d{8}$/.test(value.replace(/[^\d+]/g,''));
};

/**
 * Fourth character of phone number must not be zero
 */
export const phoneNumberFormat = (value) => {
    if (value === '') {
        return true;
    }

    const phoneNumber = value.replace(/[( |_)]/g,'');
    if (phoneNumber.charAt(3)) {
        return Number(phoneNumber[3]) !== 0;
    }

    return true;
};

export const maskedInputLength = (param) => (value) => {
    if (value === '') {
        return true;
    }

    return value.replace(/[( |_)]/g,'').length === param;
};

export const dateInOneYearRange = (value) => {
    if (value === '' || value === undefined) {
        return true;
    }

    if (value.replace(/_/g,'').length !== 10) {
        return true;
    }

    const min = moment().add(-1, 'year');
    const max = moment().add(1, 'year');

    return moment(String(value), 'DD MM YYYY').isBetween(min, max, undefined, '[]');
};

export const dateSameOrAfterConstraint = (value) => {
    if (value === '' || value === undefined) {
        return true;
    }

    if (value.replace(/_/g,'').length !== 10) {
        return true;
    }

    return moment(String(value), 'DD MM YYYY').isAfter(moment().now);
};

export const dateSameOrAfterIncludeTodayConstraint = (value) => {
    if (!isValidValue(value)) {
        return false;
    }

    return moment(String(value), 'DD MM YYYY').isAfter((moment().add(-1, 'days')));
};

export const validDateConstraint = (value) => {
    if (value === '' || value === undefined) {
        return true;
    }
    const length = value.replace(/_/g,'').length;
    if (length > 0 && length !== 10) {
        return false;
    }

    return moment(String(value), 'DD MM YYYY').isValid();
};

export const dateSameOrAfterDateConstraint = (comparedValue) => (value) => {
    if (!isValidValue(value)) {
        return false;
    }

    const date = moment(String(value), 'DD MM YYYY');

    if (!moment(String(value), 'DD MM YYYY').isValid()) {
        return true;
    }

    const index = comparedValue.indexOf('T');
    const comparedDate = comparedValue.slice(0, index);

    return date.isSameOrAfter(comparedDate);
};

export const dateSameOrBeforeDateConstraint = (comparedValue) => (value) => {
    if (!comparedValue) {
        return true;
    }
    const index = comparedValue.indexOf('T');
    let comparedDate = null;

    if (index) {
        comparedDate = comparedValue.slice(0, index);
    } else {
        return true;
    }

    if (!isValidValue(value)) {
        return false;
    }

    const date = moment(String(value), 'DD MM YYYY');

    return date.isSameOrBefore(comparedDate);
};

export const dateFromStringSameOrBeforeNowConstraint = (value) => {
    if (!value) {
        return;
    }

    const index = value.indexOf('T');
    const date = value.slice(0, index);
    const compareDate = moment(date);

    return compareDate.isSameOrBefore(moment());
};

export const isValidDateYearConstraint = (value) => {
    if (!isValidValue(value)) {
        return true;
    }

    const date = moment(String(value), 'DD MM YYYY');

    if (!moment(String(value), 'DD MM YYYY').isValid()) {
        return true;
    }
    const year = date.year();

    return year > 1800 && year < 2100;
};

export const validContributionConstraint = (value, contribution) => {
    if (!contribution.contributionMinimumPercentage) {
        return true;
    }

    return value >= contribution.contributionMinimumPercentage.employerSharePercentage;
};

export const filesizeConstraint = (maxSizeInBytes) => (value) => {
    if (null === value) {
        return true;
    }
    if (value instanceof File) {
        return value.size < maxSizeInBytes
    }

    return value.content.size < maxSizeInBytes;
};

export const fileMineTypeConstraint = (mimeTypes) => (value) => {
    if (null === value) {
        return true;
    }
    if (value instanceof File) {
        return mimeTypes.includes(value.type);
    }

    return mimeTypes.includes(value.content.type);
};

export const expirationDateAfterStartDate = (value, startDate) => {
    if (value === '' || value === undefined || value.replace(/_/g,'').length !== 10) {
        return true;
    }

    return moment(String(value), 'DD/MM/YYYY').isAfter(moment(startDate, 'DD/MM/YYYY'));
};

export const expirationDateWithinOneYear = (value, startDate) => {
    if (value === '' || value === undefined || value.replace(/_/g,'').length !== 10) {
        return true;
    }

    return moment(String(value), 'DD/MM/YYYY').isSameOrBefore(moment(startDate, 'DD/MM/YYYY').add(1, 'year'));
};

export const expirationDateInFuture = (value) => {
    if (value === '' || value === undefined || value.replace(/_/g,'').length !== 10) {
        return true;
    }

    return moment(String(value), 'DD/MM/YYYY').isSameOrAfter(moment().startOf('day'));
};

const isValidValue = (value) => {
    if (value === '' || value === undefined) {
        return true;
    }
    const length = value.replace(/_/g,'').length;

    if (length > 0 && length !== 10) {
        return false;
    }

    return true;
}
